import React from 'react';
import { describe } from '@elliemae/ds-props-helpers';
import { DSLeftNavigationPropTypesSchema, defaultProps } from './react-desc-prop-types.js';
import LeftNavigationContext from './LeftNavigationContext.js';
import { useLeftNavConfig } from './config/useLeftNavConfig.js';
import LeftNavContent from './parts/LeftNavContent/index.js';
import type { DSLeftNavigationT } from './react-desc-prop-types.js';

export const LeftNavigation = (props: DSLeftNavigationT.Props): JSX.Element => {
  const leftNavConfig = useLeftNavConfig(props);

  return (
    <LeftNavigationContext.Provider value={leftNavConfig}>
      <LeftNavContent />
    </LeftNavigationContext.Provider>
  );
};

LeftNavigation.defaultProps = defaultProps;
LeftNavigation.displayName = 'LeftNavigation';
export const LeftNavigationWithSchema = describe(LeftNavigation).description('Left Navigation');
LeftNavigationWithSchema.propTypes = DSLeftNavigationPropTypesSchema;
